import React from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
// override the default styles
import '@hex/calculators-shared/styles/sitecoreOverride.css';
import './i18next';

async function setupApp() {
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setupApp);
    return;
  }

  const root = createRoot(document.getElementById('root') as Element | DocumentFragment);

  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
  );
}

setupApp();
